export const mplus_deeplink =
  'https://app.mbank.kg/main/mplus_tranche_details_page'
